import { Address, angular, DeliveryZone, Order, Shop } from "../../types";

import OrderCalc from "./order-calc-service";
import AddressService from "../services/address-service";
import StuartService from "../services/stuart-service";
import ClientService from "../services/client-service";
import ClientOps from "../services/client-ops-service";
import _ from "lodash";
import ShopService from "../services/shop-service";
import { CHECKOUT, base_url } from "../services/constants";
import growl from "../services/growl";
import moment from "moment";
import GetrestoService from "../services/getresto-service";
import DataStore from "../services/data-store";
import CartService from "../services/cart-service";
import UrlService from "../services/url-service";
import UpsellService from "../services/UpsellService";
import PaymentService from './payment-service'
import SaleAreaService from "./SaleAreaService";
import UiService from '../services/ui-service'
import PromoService from "../services/PromoService";

let factory = {
	order: null,
	confirmedOrder: null,
	initOrderForCheckout,
	confirmOrder,
	validateStageForOrder,
	setZoneAsync,
	setShippingAddressAsync,
	setSaleAreaId,
	getNextStage,
	canConfirmOnly,
	canConfirmByFidelite,
	canConfirmByCreditCard,
	canConfirmByPayGreen,
	canConfirmByEdenred,
	canConfirmByTicketResto,
	canConfirmByComo,
	cannotConfirm,
	shouldDisplayConfirmMethods,
	shouldDisplayExistingCards,
	shouldDisplayDeliveryAddress,
	isDeliveryValid,
	isTicket,
	isPaymentValid,
	isPaymentDone,
	isDeliveryMode,
	isRestoMode,
	isClientPresent,
	isOrderConfirmed,
	isSameCarteId,
	changeShop,
	setErrorMsg,
	errorMsg: null,
	needToDisplayStage,
	afterLogin,
};

export default factory;

function afterLogin(order) {
	if (isTicket(order)) {
		UiService.openTicketModal(order)
	} else {
		UiService.openCheckoutModal();
	}
}


function initOrderForCheckout(order: Order) {
	delete order.OrderId; // all payments from inside this checkout will be as a new order (so invalid order state will not be a problem)
	SaleAreaService.validateSaleAreaId(order);
	factory.order = order;

	order.from_getresto = GetrestoService.fromGetresto;
	loadPaygreenPaymentTypesAsync(order);

	// order.SaleModeId = ShopService.SALE_MODES.CLIENT;
	order.client = ClientService.client;
	if (order.client) {
		order.ClientId = order.client.ClientId;
	} else {
		order.ClientId = order.shop.AnonClientId;
	}

	if (!isTicket(order)) {
		CartService.saveCart();
	}

	// if (order.address && !order.address.ClientId) {
	// 	ClientOps.addAddressAsync(order.client, order.address)
	// 	.then(_ => console.log('address '+ order.address.AddressId +' transferred to ' + (order.client && order.client.ClientId)));
	// }

	// if (canConfirmByFidelite(order)) {
	// 	selectFirstFidCard(order);
	// }
}

function setErrorMsg(err) {
	let msg = (_.isString(err) && err) || (_.isError(err) && err.message) || "";
	err && console.error(err);
	factory.errorMsg = msg;
	if (msg) {
		growl.error(msg);
	}
	return msg;
}

function loadPaygreenPaymentTypesAsync(order: Order) {
	if (!order.shop.paygreenPaymentTypes && canConfirmByPayGreen(order)) {
		DataStore.get(base_url + "/admin/paygreen/available-payments?ShopId=" + order.shop.ShopId, "")
			.then(data => {
				let paymentTypes = [];
				for (let i in data.availablePayments.data) {
					paymentTypes.push(data.availablePayments.data[i].platform);
				}
				order.shop.paygreenPaymentTypes = paymentTypes;
			})
			.catch(err => growl.error("Erreur lors du chargement de PayGreen"));
	}
}

function selectFirstFidCard(order) {
	if (order.client && order.client.fidelite_cards) {
		for (let i in order.client.fidelite_cards) {
			let fidCard = order.client.fidelite_cards[i];
			if (fidCard.GroupId == order.shop.GroupId && fidCard.nbPoints) {
				PaymentService.setFidelitePayment(order, fidCard);
			}
		}
	}
}

function changeShop(order: Order, shop: Shop): { status: "OK" | "KO"; msg?: string; order?: Order } {
	// SaleAreaId will be revalidated in initOrderForCheckout()
	// no need to fail here
	// if (!ShopService.hasSaleArea(shop, order.SaleModeId, order.SaleAreaId)) {
	// 	return {
	// 		status: "KO",
	// 		msg: `Le mode '${CartService.SALE_AREA_NAMES[order.SaleAreaId]}' est inactif pour cet établissement`,
	// 	};
	// }
	if (!shop.isActive) {
		return { status: "KO", msg: "L'établissement est inactif" };
	} else if (!shop.canOrder) {
		return { status: "KO", msg: "La prise de commandes est désactivée pour cet établissement" };
	}
	if (order.shop?.ShopId == shop.ShopId) {
		return { status: "OK", order };
	}

	order = CartService.changeCartShop(order, shop);
	initOrderForCheckout(order);
	UrlService.go({ name: UrlService.current().name, params: { ShopId: shop.ShopId } });
	return { status: "OK", order };
}

function setSaleAreaId(order, SaleAreaId) {
	order.SaleAreaId = SaleAreaId;
	OrderCalc.recalcFees(order);
}

function setZoneForAddressAsync(order: Order, address: Address, zone: DeliveryZone = null): Promise<boolean> {
	if (StuartService.needZone(order)) {
		if (zone) {
			return setZoneAsync(order, zone);
		} else {
			return AddressService.getZoneAsync(order.shop, address).then(zone => setZoneAsync(order, zone));
		}
	} else {
		order.deliveryZone = null;
		return Promise.resolve(true);
	}
}

function setShippingAddressAsync(order, address, zone = null) {
	return AddressService.checkAddressAsync(order, address)
		.then(address => {
			let needSaving = !address.AddressId || !address.Location || address.isModified;
			if (needSaving) {
				return ClientOps.addAddressAsync(order.client, address);
			} else {
				return address;
			}
		})
		.then(addr => setZoneForAddressAsync(order, addr, zone).then(() => addr))
		.then(addr => {
			order.AddressId = addr.AddressId;
			order.address = addr;
		})
		.then(() => StuartService.applyDeliveryFeeAsync(order));
}

function confirmOrder(orderConfirmation) {
	// merge recursively in order not to erase client.addresses, client.cards ...
	orderConfirmation.client = DataStore.normalizeClientData(orderConfirmation.client);
	orderConfirmation.shop = DataStore.normalizeShopData(orderConfirmation.shop);
	if (orderConfirmation.shop && orderConfirmation.ClientId == orderConfirmation.shop.AnonClientId) {
		delete orderConfirmation.client;
	}
	factory.order = _.merge(factory.order, orderConfirmation);

	factory.confirmedOrder = _.clone(factory.order);
	if (_.isObject(factory.confirmedOrder.OrderDate.date)) {
		factory.confirmedOrder.OrderDate = factory.confirmedOrder.OrderDate.date;
	}
	factory.order = null;
	CartService.emptyCart(true);
	// EventBus.$emit(EVENTS.orderConfirmed,factory.confirmedOrder);
}

function validateStageForOrder(order: Order, stage: string): { status: "OK" | "KO"; msg?: string; gotoStage?: string } {
	if (stage == CHECKOUT.TICKET) {
		if (isTicket(order) && !order.PaymentAmount) {
			return {
				status: "KO",
				msg: "Indiquez le montant du paiement",
				gotoStage: stage,
			};
		}
		return { status: "OK" };
	}
	if (order.OrderState == CartService.ORDER_STATES.STATE_PENDING_PAYMENT_CONFIRMATION) {
		return {
			status: "KO",
			msg: "Commande déjà en cours de paiement",
			gotoStage: undefined,
		};
	}
	if (stage == CHECKOUT.INVALID) {
		return {
			status: "KO",
			msg: "Invalid checkout state",
			gotoStage: CHECKOUT.DELIVERY_MODE,
		};
	}
	if (stage == CHECKOUT.BEFORE_START) {
		return {
			status: "OK",
		};
	}
	if (stage == CHECKOUT.SUGGESTIONS) {
		return {
			status: "OK",
		};
	}
	if (!order.SaleAreaId) {
		return {
			status: "KO",
			msg: "Choisissez où consommer",
			gotoStage: CHECKOUT.DELIVERY_MODE,
		};
	}
	if (stage == CHECKOUT.DELIVERY_MODE) {
		if (!order.isAtLanding && isDeliveryMode(order) && order.shop.MinDeliveryAmount > order.Total) {
			return {
				status: "KO",
				msg: "Montant minimum pour livraison : " + ShopService.prix(order.shop.MinDeliveryAmount),
				gotoStage: CHECKOUT.DELIVERY_MODE,
			};
		}
		return { status: "OK" };
	}

	if (stage == CHECKOUT.DELIVERY_ADDRESS) {
		if (isDeliveryMode(order)) {
			if (!order.isAtLanding && !order.AddressId) {
				return {
					status: "KO",
					msg: "Adresse de livraison indéfinie",
					gotoStage: CHECKOUT.DELIVERY_ADDRESS,
				};
			}
			if (StuartService.needZone(order)) {
				let zone = order.deliveryZone;
				if (!zone) {
					return {
						status: "KO",
						msg: "Adresse non couverte par le service de livraison",
						gotoStage: CHECKOUT.DELIVERY_ADDRESS,
					};
				}
				if (zone.MinDeliveryAmount > order.Subtotal && !order.isAtLanding) {
					return {
						status: "KO",
						msg: "Montant minimum pour livraison: " + ShopService.prix(zone.MinDeliveryAmount),
						gotoStage: CHECKOUT.DELIVERY_ADDRESS,
					};
				}
				if (zone.ShopId != order.shop.ShopId) {
					// let sister = _.find(order.shop.sister_shops,(sister)=>sister.ShopId == zone.ShopId);
					// let response = changeShop(order, sister);
					// if (response.status == 'KO') {
					return {
						status: "KO",
						msg: "La zone de livraison est invalide",
						gotoStage: CHECKOUT.DELIVERY_ADDRESS,
					};
					// }
				}
			}
		}
		return { status: "OK" };
	}

	if (stage == CHECKOUT.CHOOSE_SHOP) {
		return { status: "OK" };
	}

	if (!order.PickupTimeDate) {
		if (!isRestoMode(order)) {
			return {
				status: "KO",
				msg: "Date de livraison indéfinie",
				gotoStage: CHECKOUT.DELIVERY_DATE,
			};
		}
		order.PickupTimeDate = moment().format();
	}
	if (!isTicket(order) && !isRestoMode(order) && !ShopService.isOpenAtPickup(order)) {
		return {
			status: "KO",
			msg: "Le restaurant est fermé pour cet horaire",
			gotoStage: CHECKOUT.DELIVERY_DATE,
		};
	}
	if (stage == CHECKOUT.DELIVERY_DATE) {
		return {
			status: "OK",
		};
	}
	if (stage == CHECKOUT.CHOOSE_CONFIRM_METHOD) {
		if (order.promo_code) {
			return PromoService.validateCode(order.promo_code, order)
		} else {
			return { status: "OK" };
		}
	}

	if (stage == CHECKOUT.PAY_GREEN) {
		if (isOrderConfirmed(order)) {
			return { status: "OK" };
		}
		// soit la demande est encore en cours
		// soit elle a ete refusée
		// soit paiement terminé, mais c'etait un paiement partiel
		return {
			status: "KO",
			msg: "Le paiement n'est pas terminé",
			gotoStage: stage,
		};
	}

	if (stage == CHECKOUT.EDENRED) {
		if (isOrderConfirmed(order)) {
			return { status: "OK" };
		}
		let edenredPayment = order.paymentRequest.edenredPayments[0];
		if (edenredPayment && edenredPayment.authorize == true) {
			return { status: "OK" }; // goto PAYMENT to complete
		}
		return {
			status: "KO",
			msg: "Le paiement n'est pas terminé",
			gotoStage: stage,
		};
	}

	if (stage == CHECKOUT.PAYMENT) {
		if (isOrderConfirmed(order)) {
			return { status: "OK" };
		}
		if (!needToDisplayStage(order, stage, 1)) {
			return { status: "OK" };
		}
		if (isTicket(order)) {
			if (order.paymentSuccess == true) {
				return { status: "OK" };
			}
			if (!order.PaymentAmount) {
				return {
					msg: "Indiquez un montant pour le paiement",
					gotoStage: stage,
					status: "OK",
				};
			}
			return { status: "OK" };
		}
		let payingAmount =
			_.sumBy(order.paymentRequest.fidelitePayments, fidPayment => fidPayment.Amount) +
			_.sumBy(order.paymentRequest.comoPayments, comoPayment => comoPayment.Amount) +
			_.sumBy(order.paymentRequest.edenredPayments, edenredPayment => edenredPayment.Amount) +
			_.sumBy(order.paymentRequest.cardPayments, cardPayment => cardPayment.Amount);
		if (payingAmount < order.Remain) {
			return {
				status: "KO",
				msg: "Choisissez une carte de paiement",
				gotoStage: stage,
			};
		}
	}

	return { status: "OK" };
}

function isDeliveryMode(order) {
	return order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY;
}
function isRestoMode(order) {
	return order.SaleAreaId == ShopService.SALE_AREAS.RESTAURANT;
}
function isOrderConfirmed(order) {
	return (
		order?.OrderState == CartService.ORDER_STATES.STATE_CONFIRMED ||
		order?.OrderState == CartService.ORDER_STATES.STATE_DELIVERED
	);
}
function isTicket(order) {
	return order.SaleAreaId == ShopService.SALE_AREAS.TICKET;
}
function isClientPresent(order) {
	return isRestoMode(order) || isTicket(order);
}

function needToDisplayStage(order: Order, stage: string, direction: number) {
	let isAnonymousClient = (order: Order) => order.ClientId == order.shop.AnonClientId;

	if (stage == CHECKOUT.SALON) {
		return true;
	}
	if (stage == CHECKOUT.SUGGESTIONS) {
		return order.shop.info.upsell.suggestions.displayInCheckout
			&& UpsellService.getSuggestions().length > 0;
	}
	if (stage == CHECKOUT.HOME) {
		if (order.landingDone && direction == 1) {
			return false;
		}
		return true;
	}
	if (stage == CHECKOUT.EDIT_ADDRESS) {
		return true;
	}
	if (stage == CHECKOUT.BEFORE_START) {
		return false;
	}
	if (stage == CHECKOUT.TICKET) {
		return isTicket(order);
	}
	if (stage == CHECKOUT.DELIVERY_MODE) {
		if (isTicket(order)) {
			return false;
		}
		if (order.SaleAreaId == ShopService.SALE_AREAS.RESTAURANT) {
			return false;
		}
		if (order.landingDone && direction == 1) {
			return false;
		}
		return true;
	}
	if (stage == CHECKOUT.CHOOSE_SHOP) {
		if (isTicket(order) || isRestoMode(order) || isDeliveryMode(order)) {
			return false;
		} else if (order.shop.sister_shops.length < 2) {
			return false;
		} else if (order.landingDone && direction == 1) {
			return false;
		} else if (order.shop.ShopId != order.shop.GroupId && direction == 1) {
			// show only on main shop, unless going backwards in checkout
			return false;
		}
		return true;
	}
	if (stage == CHECKOUT.DELIVERY_ADDRESS) {
		if (order.landingDone && direction == 1) {
			return false;
		}
		return isDeliveryMode(order);
	}
	if (stage == CHECKOUT.DELIVERY_DATE) {
		if (isTicket(order) || isRestoMode(order)) {
			return false;
		}
		if (order.landingDone && direction == 1) {
			return false;
		}
		return true;
	}
	if (stage == CHECKOUT.CHOOSE_CONFIRM_METHOD) {
		return true;
	}
	if (stage == CHECKOUT.PAYMENT) {
		// now show CHECKOUT.PAYMENT even for new cards
		return !isOrderConfirmed(order);
	}
	if (stage == CHECKOUT.TICKET_SUCCESS) {
		return isTicket(order);
	}
	if (stage == CHECKOUT.SIGNUP_AFTER_CONFIRM) {
		return isAnonymousClient(order) && !order.shop.info.salon.active;
	}
	if (stage == CHECKOUT.CONFIRMED) {
		return true;
	}
}

function getNextStage(order: Order, stage: string, direction = 1): { stage: string; msg?: string } {
	// need a stack to know from which stage we've come
	// because in PAY_GREEN, we can come from NEW_CARD or PAYMENT
	let stages = [
		CHECKOUT.BEFORE_START,
		CHECKOUT.SUGGESTIONS,
		CHECKOUT.DELIVERY_MODE,
		CHECKOUT.DELIVERY_ADDRESS,
		CHECKOUT.CHOOSE_SHOP,
		CHECKOUT.DELIVERY_DATE,
		CHECKOUT.CHOOSE_CONFIRM_METHOD,
		CHECKOUT.PAYMENT,
		CHECKOUT.SIGNUP_AFTER_CONFIRM,
		CHECKOUT.CONFIRMED,
	];
	if (direction == 1) {
		var result = validateStageForOrder(order, stage);
		if (result.status == "KO") {
			return {
				stage: result.gotoStage,
				msg: result.msg,
			};
		}
	}
	let nextStage;
	if (stage == CHECKOUT.HOME) {
		nextStage = CHECKOUT.CHOOSE_CONFIRM_METHOD;
	} else if (stage == CHECKOUT.BEFORE_SALON) {
		nextStage = CHECKOUT.SALON;
	} else if (stage == CHECKOUT.SALON) {
		nextStage = CHECKOUT.CHOOSE_CONFIRM_METHOD;
	} else if (stage == CHECKOUT.EDIT_ADDRESS) {
		nextStage = CHECKOUT.DELIVERY_ADDRESS;
	} else if (stage == CHECKOUT.PAY_GREEN) {
		if (direction == -1) {
			nextStage = CHECKOUT.PAYMENT;
		} else {
			nextStage = CHECKOUT.SIGNUP_AFTER_CONFIRM;
		}
	} else if (stage == CHECKOUT.EDENRED) {
		if (direction == -1) {
			nextStage = CHECKOUT.PAYMENT;
		} else {
			nextStage = CHECKOUT.PAYMENT;
		}
	} else if (stage == CHECKOUT.DSP2) {
		if (direction == -1) {
			nextStage = CHECKOUT.PAYMENT;
		} else {
			nextStage = CHECKOUT.SIGNUP_AFTER_CONFIRM;
		}
	} else {
		let stageIndex = _.indexOf(stages, stage);
		if (stageIndex == -1) {
			let msg = "Cannot navigate: Invalid stage '" + stage + "'";
			console.error(msg);
			return {
				stage: CHECKOUT.DELIVERY_MODE,
				msg,
			};
		}
		nextStage = stages[stageIndex + direction];
		if (!nextStage) {
			return {
				stage: CHECKOUT.DELIVERY_MODE,
				msg: "Cannot navigate: Next stage not found",
			};
		}
	}
	if (needToDisplayStage(order, nextStage, direction)) {
		return { stage: nextStage };
	} else {
		let nextNext = getNextStage(order, nextStage, direction);
		return nextNext;
	}
}

function isSameCarteId(shop, otherShopId) {
	let getSister = (shop, ShopId) => _.find(shop.sister_shops, sister => sister.ShopId == ShopId);
	let sister = getSister(shop, otherShopId);
	return sister && sister.CarteId == shop.CarteId;
}

function setZoneAsync(order: Order, zone: DeliveryZone) {
	if (!zone) {
		return Promise.reject("Adresse non couverte par le service de livraison");
	}
	if (zone.MinDeliveryAmount > order.Subtotal && !order.isAtLanding) {
		return Promise.reject("Montant minimum pour livraison: " + ShopService.prix(zone.MinDeliveryAmount));
	}
	order.deliveryZone = zone;
	CartService.saveCart();
	if (zone.ShopId != order.shop.ShopId) {
		let shopOfZone = _.find(order.shop.sister_shops, sister => sister.ShopId == zone.ShopId);
		if (!shopOfZone) {
			return Promise.reject("Aucun établissement disponible pour cette adresse");
		}
		return ShopService.updateShopWithProductsAsync(shopOfZone).then(shop => {
			let response = changeShop(order, shop);
			if (response.status == "KO") {
				return Promise.reject(response.msg);
			}
			return Promise.resolve(true);
		});
	}
	return Promise.resolve(true);
}

function canConfirmByFidelite(order) {
	if (isTicket(order)) {
		return false;
	}
	return order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.BY_FIDELITE_CARD;
}
function canConfirmOnly(order) {
	if (!(order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.CONFIRM_ONLY)) {
		return false;
	}
	if (order.SaleAreaId == ShopService.SALE_AREAS.RESTAURANT) {
		return order.shop.info.confirm.restaurant;
	} else if (order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY) {
		return order.shop.info.confirm.delivery;
	} else if (order.SaleAreaId == ShopService.SALE_AREAS.TO_GO || order.SaleAreaId == ShopService.SALE_AREAS.TO_STAY) {
		return order.shop.info.confirm.clickCollect;
	} else {
		return false;
	}
}
function canConfirmByCreditCard(order) {
	return order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.BY_CREDIT_CARD;
}
function canConfirmByPayGreen(order) {
	return order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.BY_PAY_GREEN;
}
function canConfirmByEdenred(order) {
	return order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.BY_EDENRED;
}
function canConfirmByTicketResto(order) {
	return canConfirmByEdenred(order) || canConfirmByPayGreen(order);
}
function canConfirmByComo(order: Order) {
	return order.shop.confirmOrderMethods & ShopService.CONFIRM_ORDER_METHODS.BY_COMO;
}
function cannotConfirm(order) {
	return !order.shop.confirmOrderMethods;
}
function shouldDisplayConfirmMethods(order) {
	return order.shop.confirmOrderMethods != ShopService.CONFIRM_ORDER_METHODS.BY_CREDIT_CARD;
}
function shouldDisplayExistingCards(order) {
	return order.client && !_.isEmpty(order.client.cards);
}
function shouldDisplayDeliveryAddress(order) {
	return order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY;
}
function isDeliveryValid(order) {
	return order.SaleAreaId && (order.AddressId || order.SaleAreaId != ShopService.SALE_AREAS.DELIVERY);
}
function isPaymentValid(order) {
	return order.CCid && isDeliveryValid(order);
}
function isPaymentDone(order) {
	return order.OrderState == 0;
}
